import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const CutoutPreview = (props) => {
    const {platform, format, url} = props;

    return (
        <div className="ad-mode-content">
            <div className={classNames('social-img', platform, format)}>
                <div
                    className="social-media-img"
                    style={{
                        backgroundImage: `url(${url})`
                    }}
                />
            </div>
        </div>
    );
};

CutoutPreview.propTypes = {
    platform: PropTypes.string.isRequired,
    format: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
};

export default CutoutPreview;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/ad_mode/cutout_preview.js